import axios from "axios";
import "./baseApi";

// نسخه‌ی برنامه باید همیشه تازه خوانده شود تا تغییر نسخه سریع تشخیص داده شود؛
// هدرهای no-cache جلوی کش مدت‌دارِ مرورگر/پراکسی را می‌گیرند (سرویس‌ورکر هم
// روی این مسیر NetworkFirst بدون انقضای زمانی است).
const appSettings = () =>
    axios.get("AppSetting", {
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
    });
const getProvince = () => axios.get("AppSetting/GetProvince");
const getDashboard = () => axios.get("AppSetting/GetDashboard");

export default {
    appSettings,
    getProvince,
    getDashboard,
};
